export default {
  index(query = '') {
    return axios.get(`${ import.meta.env.VITE_SITE_URL }/crms/agreements${ query }`);
  },
  search(search) {
    return axios.post(`${ import.meta.env.VITE_SITE_URL }/crms/agreements/search`, { search });
  },
  currentByCrmOriginal: (id) => {
    return axios.get(`${ import.meta.env.VITE_SITE_URL }/crms/${ id }/agreements/current`);
  },
};
